import { render } from "./BaseSeparator.vue?vue&type=template&id=008e7413&scoped=true&ts=true"
import script from "./BaseSeparator.vue?vue&type=script&lang=ts"
export * from "./BaseSeparator.vue?vue&type=script&lang=ts"

import "./BaseSeparator.vue?vue&type=style&index=0&id=008e7413&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008e7413"]])

export default __exports__